module.exports = __webpack_public_path__ + "img/goPayIm.dcf8e87a.png";